import { useState, useCallback } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import macroProcessApi, { MacroProcess } from '../../../../../api/macroProcess';
import { Form } from './Form';
import { Table } from '../shared/Table';

type Props = {
  action: string;
};

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  {
    field: 'typeMacroProcessId',
    headerName: 'Tipo de Macro Proceso',
    width: 100,
  },
  { field: 'name', headerName: 'Nombre', width: 130 },
  { field: 'description', headerName: 'Descripción', width: 200 },
  { field: 'priority', headerName: 'Prioridad', width: 130 },
  { field: 'weight', headerName: 'Peso', width: 130 },
  { field: 'risks', headerName: 'Riesgos', width: 130 },
  { field: 'metaNumerics', headerName: 'Meta Numérica', width: 130 },
  { field: 'mprResult', headerName: 'Resultado Macro Proceso', width: 130 },
  { field: 'lowerLimit', headerName: 'Límite Inferior', width: 130 },
  { field: 'upperLimit', headerName: 'Límite Superior', width: 130 },
  { field: 'startValue', headerName: 'Star Value', width: 130 },
  { field: 'endValue', headerName: 'End Value', width: 130 },
  { field: 'settingDate', headerName: 'Fecha de Parametrización', width: 130 },
  { field: 'validityPeriod', headerName: 'Período de Validez', width: 130 },
  { field: 'comments', headerName: 'Observaciones', width: 200 },
  {
    field: 'isActive',
    headerName: 'Activo',
    width: 90,
  },
];

export const Wrapper: React.FC<Props> = ({ action }) => {
  const [selectedRow, setSelectedRow] = useState<MacroProcess | undefined>();
  const [macroProcesses, setMacroProcesses] = useState<MacroProcess[] | []>([]);
  const [tableError, setTableError] = useState<string>('');
  const [isTableLoading, setIsTableLoading] = useState<boolean>(true);

  const fetchMacroProcesses = useCallback(async () => {
    setIsTableLoading(true);
    try {
      const responseMacroProcesses = await macroProcessApi.getMacroProcesses();
      const macroProcessesData = responseMacroProcesses?.data;
      setMacroProcesses(macroProcessesData);
    } catch {
      setTableError('Ha ocurrido un error al obtener los macro procesos.');
    }
    setIsTableLoading(false);
  }, []);

  return action === 'add' ? (
    <Form />
  ) : (
    <>
      <Table
        setSelectedRow={setSelectedRow}
        rows={macroProcesses}
        columns={columns}
        error={tableError}
        isLoading={isTableLoading}
        setIsTableLoading={setIsTableLoading}
        fetchTable={fetchMacroProcesses}
      />
      <Form
        isEditing={action === 'modify'}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        fetchMacroProcesses={fetchMacroProcesses}
      />
    </>
  );
};
